import { render, staticRenderFns } from "./DeviceTemplatesTab.vue?vue&type=template&id=2b621e41"
import script from "./DeviceTemplatesTab.vue?vue&type=script&lang=js"
export * from "./DeviceTemplatesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports